/* eslint-disable class-methods-use-this */
import format from 'date-fns/format';
import german from 'date-fns/locale/de';

import Model from './Model';

export default class Coach extends Model {
    // noinspection JSMethodCanBeStatic
    resource() {
        return 'users/coaches';
    }

    get resourceId() {
        return `/users/${this.getPrimaryKey()}`;
    }

    get longCreatedAt() {
        return format(new Date(this.createdAt), 'DD. MMM. YYYY HH:mm', { locale: german });
    }

    get longLastLogin() {
        if (this.lastLogin === null) {
            return null;
        }

        return format(new Date(this.lastLogin), 'DD. MMM. YYYY HH:mm', { locale: german });
    }

    get avatarSmall() {
        return this.avatar
            ? `https://${process.env.VUE_APP_ROKKA}/dynamic/resize-width-60-height-60--options-dpr-2/${this.avatar}.jpg`
            : null;
    }

    get avatarBig() {
        return this.avatar
            ? `https://${process.env.VUE_APP_ROKKA}/dynamic/resize-width-300-height-300--options-dpr-2/${this.avatar}.jpg`
            : null;
    }

    get backgroundPath() {
        return this.background
            ? `https://${process.env.VUE_APP_ROKKA}/dynamic/resize-width-852-height-242--options-dpr-2/${this.background}.jpg`
            : null;
    }

    get companyLogoPath() {
        return this.companyLogo
            ? `https://${process.env.VUE_APP_ROKKA}/dynamic/resize-width-155-height-54--options-dpr-2/${this.companyLogo}.jpg`
            : null;
    }
}
